module.exports = __webpack_public_path__ + "img/liantai_full_logo.33420ad9.png";